module.exports = __webpack_public_path__ + "img/main_media_slide2.99e88212.jpg";